import { render, staticRenderFns } from "./MomentsSecurity.vue?vue&type=template&id=05089d3d"
import script from "./MomentsSecurity.vue?vue&type=script&lang=js"
export * from "./MomentsSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports